module.exports = "https://www.gc-qa.gnp.com.mx/d85ea92016117b56f2a38acb883d0758.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk_reg_front_left.png
// module id = 8097
// module chunks = 0